import { useContext } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { GroupsApi } from '../../../api-client';
import { getApiConfiguration } from '../../../common';
import { UseMutateFunction, useMutation, useQueryClient } from 'react-query';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

export const useUnassignRoleFromGroup = (
  groupId: string,
  closeGroupRoleDeleteModal: () => void,
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<void>,
      ErrorResponse,
      { groupId: string; roleId: string; isCustom?: boolean }
    >,
    'mutationFn'
  >,
): {
  unassignRole: UseMutateFunction<
    AxiosResponse<void>,
    ErrorResponse,
    { groupId: string; roleId: string; isCustom?: boolean }
  >;
  isUnassigning: boolean;
} => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const { showNotification } = useContext(NotificationsContext);
  const groupsApi = new GroupsApi(getApiConfiguration());
  const queryClient = useQueryClient();

  const onSuccess = () => {
    queryClient.invalidateQueries(`group-${groupId}-roles`).then();
    showNotification('Role successfully removed');
    closeGroupRoleDeleteModal();
  };

  const onError = () => showNotification('An error occurred!');

  const { mutate: unassignRole, isLoading: isUnassigning } = useMutation(
    ({ groupId, roleId, isCustom }) => groupsApi.unassignRole(tenantId, groupId, roleId, isCustom),
    {
      onSuccess,
      onError,
      ...options,
    },
  );

  return {
    unassignRole,
    isUnassigning,
  };
};
